import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";

import {
  capitalize,
  capitalizeAssociatedPress,
} from "../../../../helpers/string/capitalize";
import { Restricted } from "../../../../components/Restricted";

import { MEDIUM_ICON_SIZE_STYLES } from "../../../styles";
import {
  DEFAULT_BUTTON_STYLES,
  SECONDARY_BUTTON_STYLES,
} from "../../molecules/styles";

type BackLinkTails = "companies" | "sites" | "campaigns" | "users";

const LINK_RULES: {
  [key in BackLinkTails]: {
    backPermissions: string;
    entitiesTitle: string;
  };
} = {
  companies: {
    entitiesTitle: "companies",
    backPermissions: "companies:list:view",
  },
  sites: {
    entitiesTitle: "sites",
    backPermissions: "site:list:view",
  },
  campaigns: {
    entitiesTitle: "campaigns",
    backPermissions: "campaign:campaign:view",
  },
  users: {
    entitiesTitle: "users",
    backPermissions: "user:list:update",
  },
};

export const backButtonDataFromBackLink = (backLink: string) => {
  const linkKey = backLink.split("/").slice(-1)[0] as BackLinkTails;
  const { entitiesTitle, backPermissions } = LINK_RULES[linkKey];
  const backTitle = `All ${entitiesTitle}`;
  const backButtonId = `all${capitalize(entitiesTitle)}Button`;
  return { backPermissions, backTitle, backButtonId };
};

const LINK_STYLES =
  "flex max-w-fit underline focus:outline-none focus:ring-1 focus:ring-stone-500 dark:text-white text-sm font-medium rounded-md transition-colors mb-1 sm:mb-2 pr-1 py-2.5";
const BUTTON_STYLES = `${DEFAULT_BUTTON_STYLES} ${SECONDARY_BUTTON_STYLES} cursor-pointer disabled:cursor-not-allowed grow sm:min-w-[150px] sm:grow-0 shadow-none`;

export const BackLink: React.FC<{
  backLink: string;
  style: "link" | "cancel" | "go back";
}> = ({ backLink, style }) => {
  const isLink = style === "link";
  const { backPermissions, backTitle, backButtonId } =
    backButtonDataFromBackLink(backLink);
  return (
    <Restricted permissions={backPermissions}>
      <Link
        to={backLink}
        id={backButtonId}
        className={isLink ? LINK_STYLES : BUTTON_STYLES}
      >
        {isLink && <ArrowLeft className={`mr-2 ${MEDIUM_ICON_SIZE_STYLES}`} />}
        <span>{capitalizeAssociatedPress(isLink ? backTitle : style)}</span>
      </Link>
    </Restricted>
  );
};
